(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-clip-product"]) return;
  try {
    
if (!customElements.get('sr-clip-studio')) {
  customElements.define('sr-clip-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.heroArt = this.querySelector('[data-hero-art]');
      this.selectedPreview = this.querySelector('[data-selected-preview]');
      this.selectedImage = this.querySelector('[data-selected-image]');
      this.previewName = this.querySelector('[data-preview-name]');
      this.designValue = this.querySelector('[data-design-value]');
      this.methodValue = this.querySelector('[data-method-value]');
      this.selectedLabel = this.querySelector('[data-selected-label]');
      this.designList = this.querySelector('[data-design-list]');
      this.designButtons = [...this.querySelectorAll('[data-design]')];
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.designPanel = this.querySelector('[data-design-panel]');
      this.uploadPanel = this.querySelector('[data-upload-panel]');
      this.upload = this.querySelector('[data-upload]');
      this.uploadPreview = this.querySelector('[data-upload-preview]');
      this.uploadImage = this.querySelector('[data-upload-image]');
      this.uploadStatus = this.querySelector('[data-upload-status]');
      this.remove = this.querySelector('[data-remove]');
      this.objectUrl = null;

      this.designButtons.forEach(button => button.addEventListener('click', () => this.selectDesign(button)));
      this.tabs.forEach(button => button.addEventListener('click', () => this.setTab(button.dataset.tab)));
      this.querySelectorAll('[data-jump]').forEach(button => button.addEventListener('click', () => {
        const target = this.designButtons.find(item => item.dataset.design === button.dataset.jump);
        if (target) { this.selectDesign(target); target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'}); }
      }));
      this.querySelectorAll('[data-scroll-designs]').forEach(button => button.addEventListener('click', () => {
        const direction = Number(button.dataset.scrollDesigns) || 1;
        if (matchMedia('(max-width:800px)').matches) this.designList.scrollBy({left:direction * 220,behavior:'smooth'});
        else this.designList.scrollBy({top:direction * 220,behavior:'smooth'});
      }));
      this.upload?.addEventListener('change', () => this.loadUpload());
      this.remove?.addEventListener('click', () => this.clearUpload());
    }

    selectDesign(button) {
      const name = button.dataset.design || 'ScribbleRush design';
      this.designButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',String(active));
      });
      this.designValue.value = name;
      this.methodValue.value = 'Choose a ScribbleRush design';
      this.selectedLabel.textContent = name + ' selected';

      this.heroArt.hidden = false;
      this.heroArt.src = button.dataset.image;
      this.heroArt.alt = name + ' ScribbleRush full acrylic animal clip';
      this.selectedPreview.hidden = true;
      if (this.previewName) this.previewName.textContent = name;
      this.uploadPreview.hidden = true;
      this.setTab('design');
    }

    setTab(tab) {
      const uploadMode = tab === 'upload';
      this.tabs.forEach(button => {
        const active = button.dataset.tab === tab;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-selected',String(active));
      });
      this.designPanel.hidden = uploadMode;
      this.uploadPanel.hidden = !uploadMode;
      this.upload.disabled = !uploadMode;
      this.methodValue.value = uploadMode ? 'Upload my artwork' : 'Choose a ScribbleRush design';
      if (!uploadMode) this.uploadPreview.hidden = true;
      else if (this.objectUrl) {
        this.uploadPreview.hidden = false;
        this.heroArt.hidden = true;
        this.selectedPreview.hidden = true;
      }
    }

    async loadUpload() {
      const file = this.upload.files?.[0];
      if (!file) return this.clearUpload();
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 15 * 1024 * 1024) {
        this.uploadStatus.textContent = 'Please choose a JPG, PNG or WebP under 15 MB.';
        return this.clearUpload(false);
      }
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.src = url;
      try {
        await image.decode();
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = url;
        this.uploadImage.src = url;
        this.uploadPreview.hidden = false;
        this.heroArt.hidden = true;
        this.selectedPreview.hidden = true;
        this.uploadStatus.textContent = file.name + ' — preview ready.';
        this.remove.hidden = false;
        this.methodValue.value = 'Upload my artwork';
      } catch (error) {
        URL.revokeObjectURL(url);
        this.uploadStatus.textContent = 'We could not read that image. Try another file.';
        this.clearUpload(false);
      }
    }

    clearUpload(reset = true) {
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
      if (this.upload) this.upload.value = '';
      this.uploadPreview.hidden = true;
      this.remove.hidden = true;
      this.heroArt.hidden = false;
      this.selectedPreview.hidden = true;
      if (reset) this.uploadStatus.textContent = 'No image selected yet.';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-mug-studio"]) return;
  try {
    
if (!customElements.get('sr-mug-studio')) {
  customElements.define('sr-mug-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controls = new AbortController();
      this.selection = this.querySelector('[data-mug-design]');
      this.file = this.querySelector('[data-upload]');
      this.status = this.querySelector('[data-upload-status]');
      this.photo = this.querySelector('.sr-mug-photo');
      this.art = this.querySelector('.sr-mug-model-art');
      this.submit = this.querySelector('[data-submit]');
      this.version = 0;
      this.addEventListener('click', event => {
        const design = event.target.closest('[data-mug-design]');
        const mode = event.target.closest('[data-mode-button]');
        const temperature = event.target.closest('[data-temperature-button]');
        if (design) this.choose(design);
        if (mode) this.setMode(mode.dataset.modeButton);
        if (temperature) this.setTemperature(temperature.dataset.temperatureButton);
        if (event.target.closest('[data-remove-upload]')) this.clearUpload();
      }, {signal:this.controls.signal});
      this.file.addEventListener('change', () => this.loadFile(), {signal:this.controls.signal});
      this.querySelector('[data-scale]').addEventListener('input', event => {
        const value = event.target.value;
        this.querySelector('.sr-mug-model').style.setProperty('--art-scale', Number(value) / 100);
        this.querySelector('[data-scale-value]').textContent = value + '%';
        this.querySelector('[data-artwork-scale]').value = value + '%';
      }, {signal:this.controls.signal});
      this.querySelector('form').addEventListener('submit', event => {
        if (this.submit.dataset.ordersOpen !== 'true' || (this.dataset.mode === 'custom' && (!this.objectUrl || this.fileLoading))) {
          event.preventDefault();
          if (this.dataset.mode === 'custom' && !this.objectUrl) this.file.focus();
        }
      }, {signal:this.controls.signal});
      this.choose(this.selection);
    }
    disconnectedCallback() {
      this.controls?.abort();
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.ready = false;
      this.objectUrl = null;
    }
    setTemperature(value) {
      this.dataset.temperature = value;
      this.querySelectorAll('[data-temperature-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.temperatureButton === value)));
    }
    choose(button) {
      if (!button) return;
      this.selection = button;
      this.querySelectorAll('[data-mug-design]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.photo.removeAttribute('srcset');
      this.photo.src = button.dataset.mockup;
      this.photo.alt = button.dataset.alt;
      this.setMode('cartoon');
    }
    setMode(value) {
      this.dataset.mode = value;
      const custom = value === 'custom';
      this.querySelectorAll('[data-mode-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modeButton === value)));
      this.querySelector('[data-cartoon-panel]').hidden = custom;
      this.querySelector('[data-custom-panel]').hidden = !custom;
      this.file.disabled = !custom;
      this.file.required = custom;
      this.querySelector('[data-artwork-url]').disabled = custom;
      this.querySelector('[data-artwork-scale]').disabled = !custom;
      const name = custom ? this.dataset.customName : this.selection.dataset.name;
      this.querySelector('[data-design-name]').value = name;
      this.querySelector('[data-design-id]').value = custom ? 'customer-artwork' : this.selection.dataset.mugDesign;
      this.querySelector('[data-artwork-url]').value = custom ? '' : this.selection.dataset.artwork;
      this.querySelector('[data-selected-title]').textContent = name;
      this.querySelector('[data-selection]').textContent = name;
      this.art.removeAttribute('srcset');
      const source = custom ? this.objectUrl : this.selection.dataset.artwork;
      this.art.hidden = !source;
      if (source) this.art.src = source;
      else this.art.removeAttribute('src');
      this.art.alt = name;
      this.querySelector('.sr-mug-model').setAttribute('aria-label', this.dataset.previewLabel + ' ' + name);
      this.querySelector('.sr-mug-model').style.setProperty('--art-scale', custom ? Number(this.querySelector('[data-scale]').value) / 100 : .85);
      this.submit.disabled = this.submit.dataset.ordersOpen !== 'true' || (custom && (!this.objectUrl || this.fileLoading));
    }
    clearUpload(message) {
      this.version++;
      this.fileLoading = false;
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
      this.file.value = '';
      this.status.textContent = message || this.dataset.fileEmpty;
      this.status.dataset.error = String(Boolean(message));
      this.querySelector('[data-art-controls]').hidden = true;
      this.setMode('custom');
    }
    async loadFile() {
      const file = this.file.files[0];
      const ticket = ++this.version;
      if (!file) return this.clearUpload();
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) return this.clearUpload(this.dataset.fileError);
      this.fileLoading = true;
      this.submit.disabled = true;
      const source = URL.createObjectURL(file);
      const probe = new Image();
      probe.src = source;
      try {
        await probe.decode();
        if (ticket !== this.version) { URL.revokeObjectURL(source); return; }
        if (!probe.naturalWidth || !probe.naturalHeight || probe.naturalWidth * probe.naturalHeight > 40000000) throw new Error('invalid-image');
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = source;
        this.fileLoading = false;
        this.status.textContent = file.name + ' — ' + (Math.min(probe.naturalWidth, probe.naturalHeight) < 1000 ? this.dataset.fileSmall : this.dataset.fileReady);
        this.status.dataset.error = 'false';
        this.querySelector('[data-art-controls]').hidden = false;
        this.setMode(this.dataset.mode);
        this.setTemperature('hot');
      } catch (error) {
        URL.revokeObjectURL(source);
        if (ticket === this.version) this.clearUpload(this.dataset.fileError);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-video-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-video-popup')) {
    customElements.define('sr-video-popup', class extends HTMLElement {
      connectedCallback() {
        window.clearTimeout(this.initTimer);
        this.initTimer = window.setTimeout(() => { if (this.isConnected) this.initialize(); }, 0);
      }
      initialize() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.storageKey = 'scribblerush:welcome-video:v1';
        this.editor = this.dataset.editor === 'true';
        this.watch = this.querySelector('[data-vp-watch]');
        this.shop = this.querySelector('[data-vp-shop]');
        this.media = this.querySelector('[data-vp-media]');
        this.error = this.querySelector('[data-vp-error]');
        this.querySelectorAll('[data-vp-close]').forEach(button => button.addEventListener('click', () => this.closePopup(), options));
        this.querySelector('[data-vp-preview]')?.addEventListener('click', () => this.openPopup(), options);
        this.watch.addEventListener('click', () => this.playVideo(), options);
        this.dialog.addEventListener('close', () => this.afterClose(), options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closePopup(); }, options);
        this.dialog.addEventListener('pointerdown', event => { this.backdropPress = event.target === this.dialog; }, options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog && this.backdropPress) this.closePopup(); this.backdropPress = false; }, options);
        this.shop.addEventListener('click', () => this.closePopup(), options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.video?.pause(); }, options);
        window.addEventListener('pagehide', () => this.closePopup(), options);
        document.addEventListener('shopify:section:select', event => {
          if (this.editor && event.detail?.sectionId === this.dataset.sectionId) this.openPopup();
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (this.editor && event.detail?.sectionId === this.dataset.sectionId) this.closePopup();
        }, options);
        if (!this.editor && this.dataset.ready === 'true') {
          const schedule = () => { this.timer = window.setTimeout(() => this.autoOpen(), 400); };
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { ...options, once: true });
          else schedule();
        }
      }
      autoOpen() {
        if (!this.isConnected || document.hidden) return;
        const active = document.activeElement;
        if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;
        const anotherDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner')]
          .some(element => element !== this.dialog && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        if (anotherDialog) return;
        try {
          if (sessionStorage.getItem(this.storageKey)) return;
          sessionStorage.setItem(this.storageKey, 'seen');
        } catch (_) { return; }
        this.openPopup();
      }
      openPopup() {
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.error.hidden = true;
        this.dialog.removeAttribute('data-playing');
        this.media.hidden = true;
        this.watch.hidden = false;
        this.shop.hidden = true;
        if (this.video) { this.video.pause(); try { this.video.currentTime = 0; } catch (_) {} }
        try { this.dialog.showModal(); } catch (_) { return; }
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        (this.watch.disabled ? this.querySelector('[data-vp-close]') : this.watch).focus({ preventScroll: true });
      }
      playVideo() {
        if (!this.dialog.open || this.watch.disabled) return;
        this.error.hidden = true;
        if (!this.video) {
          const template = this.querySelector('[data-vp-video-template]');
          this.media.append(template.content.cloneNode(true));
          this.video = this.media.querySelector('video');
          if (!this.video) { this.error.hidden = false; return; }
          this.video.setAttribute('tabindex', '0');
          const options = { signal: this.controller.signal };
          this.video.addEventListener('ended', () => { this.shop.hidden = false; }, options);
          this.video.addEventListener('error', () => { this.error.hidden = false; }, options);
        }
        this.media.hidden = false;
        this.dialog.setAttribute('data-playing', '');
        this.watch.hidden = true;
        this.video.focus({ preventScroll: true });
        try {
          const playback = this.video.play();
          if (playback?.catch) playback.catch(() => { if (this.dialog.open) this.error.hidden = false; });
        } catch (_) { this.error.hidden = false; }
      }
      closePopup() {
        this.video?.pause();
        if (this.dialog?.open) this.dialog.close();
        this.afterClose();
      }
      afterClose() {
        this.video?.pause();
        if (!this.locked) return;
        this.locked = false;
        if (document.documentElement && document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = this.previousOverflow;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        window.clearTimeout(this.initTimer);
        window.clearTimeout(this.timer);
        this.closePopup();
        this.controller?.abort();
        this.controller = null;
        this.video = null;
        if (this.media) this.media.replaceChildren();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-world"] && !Shopify.designMode) return;
  try {
    
function srInitPromo(){document.querySelectorAll('[data-sr-promo]').forEach(video=>{if(video.dataset.ready)return;video.dataset.ready='true';if(!matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=true;video.play().catch(()=>{});}})}
srInitPromo();document.addEventListener('shopify:section:load',srInitPromo);

  } catch(e) { console.error(e); }
})();
})();
